export var AxisEnum;

!function(AxisEnum) {
    AxisEnum.lineAxis = "lineAxis", AxisEnum.circleAxis = "circleAxis";
}(AxisEnum || (AxisEnum = {}));

export var GridEnum;

!function(GridEnum) {
    GridEnum.lineAxisGrid = "lineAxisGrid", GridEnum.circleAxisGrid = "circleAxisGrid";
}(GridEnum || (GridEnum = {}));
//# sourceMappingURL=common.js.map
